<div class="row d-flex p-1 align-items-center">
    <div class="col-3 firstcol text-truncate">{{organisationUser.firstName}} {{organisationUser.prefix}} {{organisationUser.lastName}}</div>
    <div class="col-3 text-truncate">{{organisationUser.email}}</div>
    <div class="col-5 text-truncate">
        <span *ngFor="let role of organisationUser.roles; let lastitem = last">
            <span translate>Roles.{{role}}</span><span *ngIf="!lastitem">, </span>
        </span>
    </div>
    <div class="col-1 text-end">
        <ng-container *ngIf="DisplayEmailNotConfirmed()">
            <app-danger-button labelName="Settings.OrganisationUsersSection.AccountNotConfirmed"></app-danger-button>
        </ng-container>
        <div class="btn-group">
            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots bi-large"></i>
            </button>
            <ul class="dropdown-menu">
                <li *ngIf="DisplayEmailNotConfirmed()"><a class="dropdown-item pt-1 pb-1" translate="Settings.OrganisationUsersSection.ResendInvite" (click)="sendEmailReminder()"></a></li>
                <li><a class="dropdown-item pt-1 pb-1" translate="Button.Edit" (click)="openUserProfile()"></a></li>
                <li><a class="dropdown-item pt-1 pb-1" translate="Button.Delete" (click)="openDeleteUserModal()"></a></li>
            </ul>
        </div>
    </div>
</div>